/**
 *
 * AdministratorBC Requests DxGrid 14852
 *
 */

import { ReceptionDxGrid14852 } from '../ReceptionView';
import { settings } from 'containers/AdvancedDataTable/dxGridTypes';


export class AdministratorBCRequestsDxGrid14852 extends ReceptionDxGrid14852 {

    getTableFeatures() {
        const tableFeatures = super.getTableFeatures();
        const tableRowDetailIndex = tableFeatures.findIndex((field) => field.name === settings.TABLE_ROW_DETAIL);
        tableFeatures.splice(tableRowDetailIndex, 1);
        return tableFeatures;
    }
}
